import axios from "axios";

const BASE_URL = process.env.NEXT_PUBLIC_APP_API_URL;

export const SignUpApi = async ({ firstName, lastName, phoneNumber, email, password }) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/signup`,
      { firstName, lastName, phoneNumber, email, password },
      { withCredentials: true });
    return response;
  } catch (error) {
    throw error;
  }
};

export const SignInApi = async (email, password) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/signin`,
      { email, password },
      { withCredentials: true });
    return response;
  } catch (error) {
    throw error;
  }
};

export const SignOutApi = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/auth/signout`, { withCredentials: true });
    return response;
  } catch (error) {
    throw error;
  }
}

export const ForgotPasswordApi = async (email) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/forget-password`, {
      email
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export const UpdateProfile = async (userId, data) => {
  try {
    const response = await axios.put(`${BASE_URL}/auth/update?userId=${userId}`, data, { withCredentials: true });
    return response;
  } catch (error) {
    throw error;

  }
}

export const updatePassword = async (userId, oldPassword, newPassword) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/update-password?userId=${userId}`, oldPassword, newPassword, { withCredentials: true });
    return response;
  } catch (error) {
    throw error;
  }
}
